export const formatAndConvertToNumber = (value) => {
    const formattedValue = String(value).replace(',', '.');
    return Number(formattedValue) || 0;
};
